/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

export type SitesListOrderByItem = (typeof SitesListOrderByItem)[keyof typeof SitesListOrderByItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesListOrderByItem = {
  '-company': '-company',
  '-created_at': '-created_at',
  '-id': '-id',
  '-name': '-name',
  company: 'company',
  created_at: 'created_at',
  id: 'id',
  name: 'name'
} as const
